import { Vue } from 'vue-property-decorator'
import type VueRouter from 'vue-router'

import type Apis from './apis'
import { apis, logger, router, store } from './define'
import type Store from './store'
import { ILogger } from './utils/Logger'

/** Base Component
 *
 * @description vue ts 全局属性注入/继承 最佳实践, 需要依赖 vue2.x 及 vue-property-decorator
 */
export default class BaseComponent extends Vue {
    /** store 全局状态管理
     * @description 由于 Vue.use 注入的关系, 所以这里不用用getter
     */
    get $store(): Store {
        return store
    }

    set $store(store: Store) {
        // 禁止覆盖
    }

    /** 路由引用 */
    get $router(): VueRouter {
        return router
    }

    /** api接口 */
    get $apis(): Apis {
        return apis
    }

    /** 日志工具 */
    get $logger(): ILogger {
        return logger
    }

    /** 神策埋点工具 */
    // get $sensors() {
    //     return sensors
    // }
}
